var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_39605)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_743_39605",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H0V16.5H16V0.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_743_39605)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_743_39605",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H0V16.5H16V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_743_39605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19254 4.75175C8.19254 2.66472 9.89053 0.966797 11.9775 0.966797C14.0645 0.966797 15.7625 2.66472 15.7625 4.75175H8.19254Z",
    fill: "#E7BE6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1143 5.82227C15.6035 5.82227 16.0001 5.42571 16.0001 4.93653C16.0001 4.44734 15.6035 4.05078 15.1143 4.05078C14.6252 4.05078 14.2286 4.44734 14.2286 4.93653C14.2286 5.42571 14.6252 5.82227 15.1143 5.82227Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65641 10.1113C9.16888 10.1113 8.82828 9.62385 9.00015 9.16445C9.42828 8.01445 10.6189 7.18945 12.0189 7.18945C13.4189 7.18945 14.6095 8.01445 15.0376 9.16445C15.2095 9.62385 14.8689 10.1113 14.3814 10.1113H9.65641Z",
    fill: "#9289C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41166 4.63144C9.41166 2.84828 10.5801 1.3553 12.1473 0.970799C12.091 0.9683 12.0344 0.966797 11.9775 0.966797C9.89053 0.966797 8.1926 2.66472 8.1926 4.75175H9.4136C9.41246 4.71178 9.41166 4.67171 9.41166 4.63144Z",
    fill: "#E7BE6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2495 3.10151C13.9661 3.25511 13.6242 3.25511 13.3407 3.10151C13.0573 2.94793 12.7154 2.94793 12.4319 3.10151C12.1485 3.25509 11.8066 3.25509 11.5231 3.10151C11.2397 2.94793 10.8978 2.94793 10.6143 3.10151C10.3309 3.25509 9.989 3.25509 9.70553 3.10151C9.60233 3.04561 9.4914 3.01031 9.37833 2.99511C9.039 3.49629 8.84067 4.10085 8.84067 4.75171C8.84067 6.48413 10.2451 7.88856 11.9775 7.88856C13.7099 7.88856 15.1143 6.48415 15.1143 4.75171C15.1143 4.10083 14.9161 3.49629 14.5767 2.99511C14.4637 3.01031 14.3527 3.04561 14.2495 3.10151Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9082 7.70045C10.0029 7.02021 9.41165 5.89878 9.41165 4.63043C9.41165 4.08743 9.52019 3.57145 9.71519 3.10537C9.71199 3.10368 9.70872 3.10225 9.70559 3.10055C9.60239 3.04465 9.49145 3.00935 9.37839 2.99414C9.16385 3.31095 9.00585 3.66907 8.91852 4.05405C8.89385 4.05163 8.86812 4.0502 8.84072 4.0502C8.35152 4.0502 7.95499 4.44676 7.95499 4.93595C7.95499 5.42513 8.35152 5.82169 8.84072 5.82169C8.90919 5.82169 8.96845 5.81367 9.02032 5.79897C9.33299 6.681 10.029 7.38165 10.9082 7.70045Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.237579 4.75175C0.237579 2.66472 1.93552 0.966797 4.02254 0.966797C6.10955 0.966797 7.80746 2.66472 7.80746 4.75175H0.237579Z",
    fill: "#805F56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15941 5.82227C7.64861 5.82227 8.04514 5.42571 8.04514 4.93653C8.04514 4.44734 7.64861 4.05078 7.15941 4.05078C6.67021 4.05078 6.27365 4.44734 6.27365 4.93653C6.27365 5.42571 6.67021 5.82227 7.15941 5.82227Z",
    fill: "#E8B57F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70138 10.1113C1.21388 10.1113 0.873253 9.62385 1.04513 9.16445C1.47325 8.01445 2.66388 7.18945 4.06388 7.18945C5.46388 7.18945 6.65451 8.01445 7.0826 9.16445C7.25453 9.62385 6.91387 10.1113 6.42638 10.1113H1.70138Z",
    fill: "#43A695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4567 4.63144C1.4567 2.84828 2.62512 1.3553 4.19232 0.970799C4.13603 0.9683 4.07948 0.966797 4.02258 0.966797C1.93556 0.966797 0.23764 2.66472 0.23764 4.75175H1.45868C1.45749 4.71178 1.4567 4.67171 1.4567 4.63144Z",
    fill: "#805F56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29457 3.10151C6.0111 3.25511 5.66924 3.25511 5.38577 3.10151C5.1023 2.94793 4.76044 2.94793 4.47698 3.10151C4.1935 3.25509 3.85165 3.25509 3.56818 3.10151C3.2847 2.94793 2.94285 2.94793 2.65938 3.10151C2.3759 3.25509 2.03405 3.25509 1.75058 3.10151C1.6474 3.04561 1.53644 3.01031 1.42341 2.99511C1.08402 3.49629 0.885742 4.10085 0.885742 4.75171C0.885742 6.48413 2.29014 7.88856 4.02258 7.88856C5.75501 7.88856 7.1594 6.48415 7.1594 4.75171C7.1594 4.10083 6.96114 3.49629 6.62174 2.99511C6.50871 3.01031 6.39776 3.04561 6.29457 3.10151Z",
    fill: "#E8B57F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95319 7.70045C2.04789 7.02021 1.45667 5.89878 1.45667 4.63043C1.45667 4.08743 1.5652 3.57145 1.76017 3.10537C1.75701 3.10368 1.75373 3.10225 1.75058 3.10055C1.64739 3.04465 1.53645 3.00935 1.42341 2.99414C1.20888 3.31095 1.05084 3.66907 0.963507 4.05405C0.938893 4.05163 0.913147 4.0502 0.885747 4.0502C0.396561 4.0502 0 4.44676 0 4.93595C0 5.42513 0.396561 5.82169 0.885747 5.82169C0.954213 5.82169 1.0135 5.81367 1.06531 5.79897C1.37797 6.681 2.07401 7.38165 2.95319 7.70045Z",
    fill: "#E8B57F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23758 10.5857C4.23758 8.49868 5.93552 6.80078 8.02253 6.80078C10.1095 6.80078 11.8075 8.49868 11.8075 10.5857H4.23758Z",
    fill: "#E7886E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1594 11.6563C11.6486 11.6563 12.0451 11.2597 12.0451 10.7705C12.0451 10.2814 11.6486 9.88477 11.1594 9.88477C10.6702 9.88477 10.2737 10.2814 10.2737 10.7705C10.2737 11.2597 10.6702 11.6563 11.1594 11.6563Z",
    fill: "#FFE0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70138 15.9434C5.21388 15.9434 4.87325 15.4559 5.04513 14.9965C5.47325 13.8465 6.66388 13.0215 8.06387 13.0215C9.46387 13.0215 10.6545 13.8465 11.0826 14.9965C11.2545 15.4559 10.9139 15.9434 10.4264 15.9434H5.70138Z",
    fill: "#5C586F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45664 10.4654C5.45664 8.68228 6.62506 7.18928 8.19226 6.80478C8.13599 6.80229 8.07946 6.80078 8.02253 6.80078C5.9355 6.80078 4.23758 8.49868 4.23758 10.5857H5.45863C5.45743 10.5457 5.45664 10.5057 5.45664 10.4654Z",
    fill: "#E7886E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2946 8.93546C10.0111 9.08906 9.66927 9.08906 9.3858 8.93546C9.10227 8.78193 8.76047 8.78193 8.477 8.93546C8.19347 9.08906 7.85167 9.08906 7.5682 8.93546C7.28467 8.78193 6.94287 8.78193 6.65938 8.93546C6.3759 9.08906 6.03405 9.08906 5.75058 8.93546C5.6474 8.8796 5.53644 8.84426 5.42341 8.82906C5.08402 9.33026 4.88574 9.9348 4.88574 10.5857C4.88574 12.3181 6.29014 13.7225 8.0226 13.7225C9.755 13.7225 11.1594 12.3181 11.1594 10.5857C11.1594 9.9348 10.9611 9.33026 10.6217 8.82906C10.5087 8.84426 10.3977 8.8796 10.2946 8.93546Z",
    fill: "#FFE0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9532 13.5345C6.04789 12.8542 5.45667 11.7328 5.45667 10.4645C5.45667 9.92146 5.5652 9.40546 5.76017 8.93939C5.75701 8.93766 5.75373 8.93626 5.75058 8.93453C5.64739 8.87866 5.53645 8.84332 5.42341 8.82812C5.20888 9.14492 5.05084 9.50306 4.96351 9.88806C4.93889 9.88566 4.91315 9.88419 4.88575 9.88419C4.39656 9.88419 4 10.2808 4 10.7699C4 11.2591 4.39656 11.6557 4.88575 11.6557C4.95421 11.6557 5.0135 11.6477 5.06531 11.633C5.37797 12.515 6.07401 13.2157 6.9532 13.5345Z",
    fill: "#FFE0C0"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_39605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.449af4f7083d2349185bcd3843896a05.svg";
export { ForwardRef as ReactComponent };